import type { PackageInterface } from '~/types/shipzeePro/packagesTypes'

import type { CourierInterface, CourierPackageInterface } from '~/types/shipzeePro/shipzeeProTypes'

export default (courier: CourierInterface, selectedPackages: PackageInterface[]): CourierPackageInterface | null => {
  const packages: CourierPackageInterface[] = Object.values(courier.packages)

  for (const courierPackage of packages) {
    if (canBeShippedUsingPackage(courierPackage, selectedPackages)) {
      return Object.assign(courierPackage)
    }
  }

  return null
}

function dimensionsFit(maxes: number[], values: number[]): boolean {
  return maxes[0] >= values[0] && maxes[1] >= values[1] && maxes[2] >= values[2]
}

function canBeShippedUsingPackage(
  courierPackage: CourierPackageInterface,
  selectedPackages: PackageInterface[]
): boolean {
  let totalWeight = 0
  let totalVolume = 0
  const courierDimensions = [courierPackage.width, courierPackage.height, courierPackage.length].sort((a, b) => b - a)

  for (const selectedPackage of selectedPackages) {
    const selectedPackageDimensions = [selectedPackage.height, selectedPackage.width, selectedPackage.length].sort(
      (a, b) => b - a
    )

    if (!dimensionsFit(courierDimensions, selectedPackageDimensions)) {
      return false
    }

    totalWeight += selectedPackage.weight
    totalVolume += selectedPackageDimensions.reduce((c, v) => c * v, 0)
  }

  return (
    courierPackage.weight >= totalWeight && courierDimensions.reduce((c: number, v: number) => c * v, 0) >= totalVolume
  )
}
